export const zIndexes = {
    topNavigation: 1,
    drawer: 6,
}
